import { render } from "./Success.vue?vue&type=template&id=3524c032&scoped=true"
import script from "./Success.vue?vue&type=script&lang=js"
export * from "./Success.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3524c032"

export default script